import { useState } from 'react';

export type UserSortField = 'id' | 'displayName' | 'email' | 'clientName';
export type UserSortOrder = 'asc' | 'desc';

export const USER_SORT_FIELD_LABELS: Record<UserSortField, string> = {
  id: 'UUID',
  displayName: 'Display Name',
  email: 'Email',
  clientName: 'Client',
};

interface UserSortFilterModalProps {
  sortField: UserSortField;
  sortOrder: UserSortOrder;
  onApply: (sortField: UserSortField, sortOrder: UserSortOrder) => void;
  onClose: () => void;
}

const selectClassName =
  'w-full px-2.5 py-1.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm';

export function UserSortFilterModal({
  sortField,
  sortOrder,
  onApply,
  onClose,
}: UserSortFilterModalProps) {
  const [field, setField] = useState(sortField);
  const [order, setOrder] = useState(sortOrder);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-xl shadow-lg w-full max-w-xs mx-4">
        <div className="px-4 pt-4 pb-3">
          <h2 className="text-base font-bold text-gray-900 mb-3">Sort</h2>
          <div className="flex items-end gap-2">
            <div className="flex-1 min-w-0">
              <label htmlFor="user-sort-field" className="block text-xs font-medium text-gray-500 mb-1">
                Sort by
              </label>
              <select
                id="user-sort-field"
                value={field}
                onChange={(e) => setField(e.target.value as UserSortField)}
                className={selectClassName}
              >
                {(Object.keys(USER_SORT_FIELD_LABELS) as UserSortField[]).map((key) => (
                  <option key={key} value={key}>{USER_SORT_FIELD_LABELS[key]}</option>
                ))}
              </select>
            </div>
            <div className="w-28 shrink-0">
              <label htmlFor="user-sort-order" className="block text-xs font-medium text-gray-500 mb-1">
                Order
              </label>
              <select
                id="user-sort-order"
                value={order}
                onChange={(e) => setOrder(e.target.value as UserSortOrder)}
                className={selectClassName}
              >
                <option value="asc">Asc</option>
                <option value="desc">Desc</option>
              </select>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-end gap-2 px-4 py-3 border-t border-gray-100">
          <button
            type="button"
            onClick={onClose}
            className="px-3 py-1.5 text-sm font-medium text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => onApply(field, order)}
            className="px-3 py-1.5 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
}
